import { Component } from '@angular/core';
import { UserTableComponent } from 'gung-standard';

@Component({
  selector: 'car-liner-user-table',
  templateUrl: './car-liner-user-table.component.html',
  styleUrls: ['./car-liner-user-table.component.css'],
  standalone: false
})
export class CarLinerUserTableComponent extends UserTableComponent {}
